import {
  LANDING_DETAIL_TYPOGRAPHY,
  LANDING_ENROLL_GRID,
  LANDING_TYPOGRAPHY,
} from "../constants/landing.constants";
import type { LandingCourse } from "../types/landing.types";
import LandingIcon from "./LandingIcon";

type StepIconName = "keyboard" | "wallet" | "notebook";

interface EnrollStepsProps {
  steps: LandingCourse["enrollSteps"];
}

export default function EnrollSteps({ steps }: EnrollStepsProps) {
  return (
    <section>
      <h2 className={`mb-5 ${LANDING_TYPOGRAPHY.subsectionTitle}`}>
        How To Enroll & Access Class
      </h2>
      <div className={LANDING_ENROLL_GRID}>
        {steps.map((step, index) => {
          const iconName = step.icon as StepIconName;
          return (
            <div
              key={step.title}
              className={LANDING_DETAIL_TYPOGRAPHY.enrollCard}
            >
              <span className={LANDING_DETAIL_TYPOGRAPHY.stepNumber}>
                {index + 1}
              </span>
              <LandingIcon
                name={iconName}
                className={LANDING_DETAIL_TYPOGRAPHY.stepIcon}
              />
              <div className={LANDING_DETAIL_TYPOGRAPHY.stepHeaderSpace} aria-hidden />
              <h3 className={LANDING_DETAIL_TYPOGRAPHY.stepTitle}>{step.title}</h3>
              <p className={LANDING_DETAIL_TYPOGRAPHY.stepBody}>
                {step.description}
              </p>
            </div>
          );
        })}
      </div>
    </section>
  );
}
